const VideoPlayer = ({ src, mimeType, disableDownload = true }) => {
  // Prevent right-click context menu on video
  const handleContextMenu = (e) => {
    if (disableDownload) {
      e.preventDefault();
      return false;
    }
  };

  return (
    <video 
      controls 
      width="100%" 
      key={src} 
      controlsList={disableDownload ? "nodownload noremoteplayback" : ""} 
      disablePictureInPicture={disableDownload}
      playsInline
      onContextMenu={handleContextMenu}
      style={{ outline: 'none' }}
    >
      <source src={src} type={mimeType} />
      Your browser does not support the video element.
    </video>
  );
};

export default VideoPlayer;
